/* eslint-disable react/react-in-jsx-scope */
import {
  DashboardOutlined,
  BankOutlined,
  DollarOutlined,
  UserOutlined,
  SwapOutlined,
  WalletOutlined,
  RiseOutlined,
  PercentageOutlined,
  TeamOutlined,
  FileTextOutlined,
  ReloadOutlined,
  FileProtectOutlined,
  QuestionCircleOutlined,
  BookOutlined,
  SettingOutlined,
} from '@ant-design/icons';

const sideBarMenu = [
  {
    label: 'Overview',
    to: '/',
    icons: {
      inActive: <DashboardOutlined />,
      active: <DashboardOutlined />,
    },
  },
  {
    label: 'Bank Pledge',
    to: '/pledge',
    icons: {
      inActive: <BankOutlined />,
      active: <BankOutlined />,
    },
  },
  {
    label: 'Loan',
    to: '/loan',
    icons: {
      inActive: <DollarOutlined />,
      active: <DollarOutlined />,
    },
  },
  {
    label: 'Sale',
    to: '/sales',
    icons: {
      inActive: <DollarOutlined />,
      active: <DollarOutlined />,
    },
  },
  {
    label: 'Customer',
    to: '/customer',
    icons: {
      inActive: <UserOutlined />,
      active: <UserOutlined />,
    },
  },
  {
    label: 'Transactions',
    to: '/transaction',
    icons: {
      inActive: <SwapOutlined />,
      active: <SwapOutlined />,
    },
  },
  {
    label: 'Deposits',
    to: '/deposit',
    icons: {
      inActive: <WalletOutlined />,
      active: <WalletOutlined />,
    },
  },
  {
    label: 'Investment',
    to: '/investment',
    icons: {
      inActive: <RiseOutlined />,
      active: <RiseOutlined />,
    },
  },
  {
    label: 'Interest Scheme',
    to: '/interest-scheme',
    icons: {
      inActive: <PercentageOutlined />,
      active: <PercentageOutlined />,
    },
  },
  {
    label: 'Users',
    to: '/users',
    icons: {
      inActive: <TeamOutlined />,
      active: <TeamOutlined />,
    },
  },
  {
    label: 'Reports',
    to: '/reports',
    icons: {
      inActive: <FileTextOutlined />,
      active: <FileTextOutlined />,
    },
  },
  {
    label: 'Cash Bank Book',
    to: '/cash-bank-book',
    icons: {
      inActive: <BookOutlined />,
      active: <BookOutlined />,
    },
  },
  {
    label: 'Recovery',
    to: '/recovery',
    icons: {
      inActive: <ReloadOutlined />,
      active: <ReloadOutlined />,
    },
  },
  {
    label: 'Terms',
    to: '/terms',
    icons: {
      inActive: <FileProtectOutlined />,
      active: <FileProtectOutlined />,
    },
  },
  {
    label: 'Bank Guide',
    to: '/help',
    icons: {
      inActive: <QuestionCircleOutlined />,
      active: <QuestionCircleOutlined />,
    },
  },
  {
    label: 'Settings',
    to: '/settings',
    icons: {
      inActive: <SettingOutlined />,
      active: <SettingOutlined />,
    },
  },
];

export default sideBarMenu;
